export function explicitBoolean(value) {
  const normalized = String(value ?? "")
    .trim()
    .toLowerCase();

  if (
    normalized === "true" ||
    normalized === "1" ||
    normalized === "yes" ||
    normalized === "on"
  ) {
    return true;
  }

  if (
    normalized === "false" ||
    normalized === "0" ||
    normalized === "no" ||
    normalized === "off"
  ) {
    return false;
  }

  return null;
}

export function childrensBookPilotEnabled(
  env = process.env
) {
  return (
    explicitBoolean(
      env?.REACT_APP_ENABLE_PROJECT_HUB_CHILDRENS_BOOK_PILOT
    ) === true
  );
}
